import { createContext, useContext, type ReactNode } from 'react';
import { DENSITY, type Density, type DensityScale } from './tokens';

/**
 * Density is a property of WHERE you are, not of each call site.
 *
 * The public site and the back office need different densities, and threading a
 * `density` prop through every Button and Card would put the decision in the
 * hands of whoever wrote the page. Each shell provides its tier once instead.
 *
 * Defaults to `public`: a primitive rendered outside any shell — a login screen,
 * a test — should be the forgiving size, not the dense one.
 */
const DensityContext = createContext<Density>('public');

export function DensityProvider({
  density,
  children,
}: {
  density: Density;
  children: ReactNode;
}) {
  return <DensityContext.Provider value={density}>{children}</DensityContext.Provider>;
}

export function useDensity(): Density {
  return useContext(DensityContext);
}

export function useDensityScale(): DensityScale {
  return DENSITY[useDensity()];
}

/** Picks one of two class strings by tier. The workhorse inside primitives. */
export function useDensityClass(map: Record<Density, string>): string {
  return map[useDensity()];
}
